import styled from '@emotion/styled';
import { Typography } from '@mgmresorts/mgm-ui';

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: 80px 0;
  text-align: center;
  position: relative;
`;

export const StyledIcon = styled.div`
  font-size: ${({ theme }) => theme.semantic.SizeIconL64};
  color: ${({ theme }) => theme.semantic.FgDefault};
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
`;

export const StyledTitle = styled(Typography)`
  color: ${({ theme }) => theme.semantic.PropertiesW900};
  margin: ${({ theme }) => theme.semantic.SpaceComponentM}px 0;
`;
